// BBPS
import mobile from "../../assets/Images/Mobilepostpaid.webp";
import mobileprepaid from "../../assets/Images/Mobileprepaid.webp";
import dth from "../../assets/Images/DTH.webp";

import electricity from "../../assets/Images/Electricity.webp";
import water from "../../assets/Images/Water.webp";
import gas from "../../assets/Images/Pipedgas.webp";
import cylinder from "../../assets/Images/LPGcylinder.webp";

import credit from "../../assets/Images/Creditcard.webp";
import loan from "../../assets/Images/Loanrepayment.webp";
import insurance from "../../assets/Images/Insurance.webp";

import fastTag from "../../assets/Images/FASTag.webp";
import municipal from "../../assets/Images/Municipaltax.webp";
import Broadband from "../../assets/Images/Broadband.webp";
import tuition from "../../assets/Images/Educationfee.webp";
import bharat from "../../assets/Images/BharatConnectNew.webp";

// CreditCardBillPayments
import ntarLoader from "../../assets/Images/addcards.json";
import Addcard from "../../assets/Images/cdaddcardicon.webp";

// SettlementsNew
import Revenue from "../../assets/Images/revenue.svg";
import CopyIcon from "../../assets/Images/copy.png";
import NewAvatar from "../../assets/Images/newavatar.png";
import bank from "../../assets/Images/bank.png";

// Get paid addamount
import rupay from "../../assets/Images/rupay.png";
import visa from "../../assets/Images/Visa.png";
import master from "../../assets/Images/MasterCard.png";
import mobileCardImg from "../../assets/Images/vyshucall4.svg";
import cardNumImg from "../../assets/Images/vyshunewcard1.svg";
import personCardImg from "../../assets/Images/vyshuname3.svg";
import personImg from "../../assets/Images/personCardImg.png";
import monthImg from "../../assets/Images/vyshummcvv2.svg";

// paymentLinks
import moneyReceive from "../../assets/Images/money-receive.png";

//paymentLinks/Details
import mobileImg from "../../assets/Images/mobileImg.png";
import emailImg from "../../assets/Images/emailImg.png";
import desImg from "../../assets/Images/descriptionImg.png";
import DateImg from "../../assets/Images/dateImg.png";
import tickImg from "../../assets/Images/tickImg.png";
import ShareLink from "../../assets/Images/link.json";

//Pos
import orangeentername from "../../assets/Images/orangeentername.svg";
import orangecall from "../../assets/Images/call.svg";
import orangemail from "../../assets/Images/mail.svg"
import orangeRemarks from "../../assets/Images/remarks.svg"

// Payservice
import addpayee from "../../assets/Images/Payee gif.gif";
import orange_icons from "../../assets/Images/orange coin flip.png";
import sidegrayprofile from "../../assets/Images/grayprofile.svg";
import orangeifsc from "../../assets/Images/orangeifsc.svg";
import payeebank from "../../assets/Images/payeebank.webp";
import Ifsc from "../../assets/Images/ifsc.svg";
import Pan from "../../assets/Images/pan.svg";
import orangePan from "../../assets/Images/orangepan.svg";

//History
import paymentRecieveds from ".././../assets/Images/paymentRecieved.svg";
import paymentSent from "../../assets/Images/paymentSent.svg";
import walletCoin from "../../assets/Images/walletCoin.svg";

//Demo
import ntarbizzlogo from "../../assets/Images/webntarbizzlogo.svg";
import Plus from "../../assets/Images/plus.png";
import ntarbizzcoin from "../../assets/Images/bizzcoin.webp";
import Profile from "../../assets/Images/headerprofileicon.png";
import sidemenuicon from "../../assets/Images/menuiconside.svg";
import Bharatconnect from "../../assets/Images/bharatconnect.svg";
import PayBillIcon from "../../assets/Images/Paybillsicon.png";
import CCBillIcon from "../../assets/Images/CCBP.png";
import SettlementsIcon from "../../assets/Images/Settlementsicon.png";
import GedPaidIcon from "../../assets/Images/Getpaid.png";
import PaymentLinksIcon from "../../assets/Images/paymentlinks.png";
import PosIcon from "../../assets/Images/posicon.png";
import QrIcon from "../../assets/Images/QrIcon.png";
import PartnerIcon from "../../assets/Images/partner.png";
import ReferralIcon from "../../assets/Images/Referral.png";
import TransactionsIcon from "../../assets/Images/TransactionIcon.png";
import HelpIcon from "../../assets/Images/helpicon.png";
import LogoutIcon from "../../assets/Images/LogoutIcon.png";

// CreditCardPaymentPay Links
import natrbizz_logo from "../../assets/Images/webntarbizzlogo.svg";
import groupcard from "../../assets/Images/cardGroup.png";
import card from "../../assets/Images/Card.png";
import ExpiredLink from "../../assets/Images/ExpiredLink.png";

//CreditCardPayment methods
import payDImg from "../../assets/Images/payDImg.png";
import cardimg from "../../assets/Images/cardImg.png";

//PayNowCreditcard
import emptyCard from "../../assets/Images/Instantly.svg";
import AddcreditCard from "../../assets/Images/addcreditcard.png";

//PaywithCreditcard
import Instantly from "../../assets/Images/Instantly.svg";
import couponcongrats from "../../assets/Images/couponcongrats.webp";
import Happy from "../../assets/Images/happy.png";
import CouponsImg from "../../assets/Images/coupons.svg";

//Payment Method
import creditCardPay from "../../assets/Images/Card.png";
import paySide from "../../assets/Images/side.webp";

// TransactionDetailsModal
import rupay_icons from "../../assets/Images/rupes_pay.png";
import receipt from "../../assets/Images/receipt-item.png";
import sharereceipt from "../../assets/Images/sharereceipt.png";
import helpquestionmark from "../../assets/Images/helpquestionmark.png";
import headerIcon from "../../assets/Images/Transaction_header_icon.png";
import walletImg from "../../assets/Images/receiptwallet.png";

// Common_icons
import bharatLogo from "../../assets/Images/Bharat Connect Primary Logo_SVG 3.png";
import Complaint from "../../assets/Images/Complaints.png";
import ntarLoaders from "../../assets/Images/ntarLoader.json";
import Payment from "../../assets/Images/paymentimg.png";
import IMPS from "../../assets/Images/IMPS.png";
import NEFT from "../../assets/Images/neft.png";
import settlement from "../../assets/Images/settlement.png";
import Helpsupport from "../../assets/Images/Girldrinkingcoffee.png";
import Timergif from "../../assets/Images/timergif.svg";
import Linecoingif from "../../assets/Images/linecoingif.webp";
import bankwd from "../../assets/Images/bankwd.png";
import panwd from "../../assets/Images/panwd.png";
import edit from "../../assets/Images/edit.png"
import menu from "../../assets/Images/menu.png"
import jio from "../../assets/Images/jio.webp"
import airtel from "../../assets/Images/airte.webp"
import vodafoneidea from "../../assets/Images/vodafoneidea.webp"
import bsnl from "../../assets/Images/bsnl.webp"
import creditCardAnime from "../../assets/Images/cards.json"
import QrAnime from "../../assets/Images/Qr1.json"
import ElectricityAnime from "../../assets/Images/Electricity.json"
import FasttagAnime from "../../assets/Images/Fast tag.json"
import road from "../../assets/Images/road.png"

export const ImagesPath = {
    orange_icons, bharatLogo,Complaint,ntarLoaders,
    Payment,IMPS,NEFT,settlement,Helpsupport,road,
    Timergif,Linecoingif,bankwd,panwd,bank,edit,menu,jio,airtel,vodafoneidea,bsnl,creditCardAnime,QrAnime,ElectricityAnime,FasttagAnime,
    BBPS: {
            mobilePostpaid: mobile,
            mobilePrepaid: mobileprepaid,
            dth: dth,
            electricity,
            water,
            pipedGas: gas,
            lpgCylinder: cylinder,
            creditCard: credit,
            loanRepayment: loan,
            insurance,
            fastTag,
            municipalTax: municipal,
            broadband: Broadband,
            educationFee: tuition,
            BharatConnection: bharat
    },
    CreditCardBillPayments:{
            NtarLoader: ntarLoader,
            Addcard
    },
    Settlement:{
        Revenue,
        CopyIcon,
        NewAvatar,
        bank
    },
    GetPaidAddamount:{
        rupay,
        visa,
        master,
        mobileCardImg,
        cardNumImg,
        personCardImg,
        monthImg
    },
    PayMentLinks:{
        moneyReceive,
        details:{
            mobileImg,
            emailImg,
            desImg,
            DateImg,
            tickImg,
            ShareLink,
            personCardImg
        }
    },
    POS:{
        orangeentername,
        orangecall,
        orangemail,
        orangeRemarks
    },
    Payservice:{
        addpayee,
        orange_icons,
        sidegrayprofile,
        orangeentername,
        orangeifsc,
        payeebank,
        Ifsc,
        Pan,
        orangePan
    },
    History:{
        paymentRecieveds,
        paymentSent,
        walletCoin
    },
    Demo:{
        ntarbizzlogo,
        Plus,
        ntarbizzcoin,
        Profile,
        sidemenuicon,
        Bharatconnect,
        PayBillIcon,
        CCBillIcon,
        SettlementsIcon,
        GedPaidIcon,
        PaymentLinksIcon,
        PosIcon,
        QrIcon,
        PartnerIcon,
        ReferralIcon,
        TransactionsIcon,
        HelpIcon,
        LogoutIcon

    },
    CreditCardpayLinks:{
        natrbizz_logo,
        groupcard,
        card,
        ExpiredLink
    },
    CreditcardMethod:{
        payDImg,
        cardimg
    },
    PayNowcard:{
        emptyCard,
        AddcreditCard
    },
    PaymentCard:{
        creditCardPay,
        paySide,
        ntarbizzlogo
    },
    PaywithCreditcard:{
        Instantly,
        couponcongrats,
        Happy,
        CouponsImg
    },
    TransactionDetailsModal:{
        headerIcon,
        walletImg,
        rupay_icons,
        receipt,
        sharereceipt,
        helpquestionmark
    }

};


// import {ImagesPath}  from '../../Common/imagespath/imagespath';